import logo from '@kargotech/tms-common/Assets/Images/Logo/VendorCentral/dantms-logo.png';
import defaultConfig from './dantms.json';

export default {
  ...defaultConfig,
  logo,
  projectUrl: (global.location && global.location.origin) || 'https://dantms.com',
};
